export default __webpack_public_path__ + "static/media/gm-frens.d99508e8.jpeg";